import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any, type: any) => {
  let data = isSuccessResponse(response)
  if (type === 'REQ_TYPE') {
    data = { [`${'DEFAULT'}`]: 'DEFAULT', ...data }
  }
  return data
}

const getCodeNames = (type: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.codeNames),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      type: type,
    },
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp, type))
    .catch((error) => {
      throw error
    })
}

export { getCodeNames }
